<template>
  <div class="top" v-if="showTop">
    <div class="gametitle">
      {{ $t(`lang.str_detail`) }}
    </div>
  </div>
</template>
<script >

export default {
  name: "GameTitleLayout",
  components: {

  },
  props: {
    showTop: false,
    Phone: false,
  }
}
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/common/game_detail_title.vue